import { fabric } from 'fabric';
import { DEFAULT_OBJECT_COLOR } from '../utils/common';

const defaultOptions: fabric.RectOptions = {
  fill: DEFAULT_OBJECT_COLOR,
};

const RectBase = fabric.util.createClass(fabric.Rect, {
  type: 'rect-base',

  initialize: function (options: fabric.RectOptions) {
    this.callSuper('initialize', {...defaultOptions, ...options});
  },
});

RectBase.fromObject = function (object: fabric.Object, callback: (obj: fabric.Object) => void) {
  const obj = new RectBase(object);
  if (callback) callback(obj);
  return obj;
};

export default RectBase;
